// extracted by mini-css-extract-plugin
export default {"heading_bg":"Counter_heading_bg__lkGgq","top_section":"Counter_top_section__-Ebma","cardList":"Counter_cardList__B53o+","col":"Counter_col__OTqmP","card":"Counter_card__eePDo"};